import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import uiSlice from '@/store/slices/uiSlice'
import authSlice from '@/store/slices/authSlice'
import profileSlice from '@/store/slices/profileSlice'
import dashboardSlice from '@/store/slices/dashboardSlice'
import paginationSlice from '@/store/slices/paginationSlice'
import modalSlice from '@/store/slices/modalSlice'
import userSlice from '@/store/slices/userSlice'
import analysisSlice from '@/store/slices/analysisSlice'
import transactionSlice from '@/store/slices/transactionSlice'
import selfExclusionSlice from '@/store/slices/selfExclusionSlice'
import subscriptionSlice from '@/store/slices/subscriptionSlice'
import settingsSlice from '@/store/slices/settingsSlice'

const authPersistConfig = { key: 'auth', storage, whitelist: ['isAuth', 'isLogin', 'token', 'auth'] }
const profilePersistConfig = { key: 'profile', storage, whitelist: ['user'] }

const persistedAuthReducer = persistReducer(authPersistConfig, authSlice)
const persistedProfileReducer = persistReducer(profilePersistConfig, profileSlice)

export const store = configureStore({
    reducer: {
        ui: uiSlice,
        auth: persistedAuthReducer,
        profile: persistedProfileReducer,
        dashboard: dashboardSlice,
        pagination:paginationSlice,
        modal: modalSlice,
        user: userSlice,
        analysis: analysisSlice,
        transaction: transactionSlice,
        selfExclusion: selfExclusionSlice,
        subscription: subscriptionSlice,
        settings: settingsSlice
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/PURGE']
            }
        })
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
